import moment from 'moment'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
const useYearList = () => {
	const { i18n } = useTranslation()
	const { language } = i18n
	const yearList = useMemo(() => {
		const yearList = [
			{
				value: moment(new Date()).format('YYYY'),
				title_uz: moment(new Date()).format('YYYY'),
			},
			{
				value: moment().subtract(1, 'year').year(),
				title_uz: moment().subtract(1, 'year').year(),
			},
			{
				value: moment().subtract(2, 'year').year(),
				title_uz: moment().subtract(2, 'year').year(),
			},
			{
				value: moment().subtract(3, 'year').year(),
				title_uz: moment().subtract(3, 'year').year(),
			},
			{
				value: moment().subtract(4, 'year').year(),
				title_uz: moment().subtract(4, 'year').year(),
			},
		]
		const newYearList = yearList.map(year => ({
			...year,
			label: year?.['title_' + language],
		}))
		return newYearList
	}, [language])
	return yearList
}
export default useYearList
